// Reference: wan25ai. Public product identifiers belong in code, not environment variables.
// Wan22.io subscription products and hosted payment links, verified against Anyway Business.
// Subscription productId: null disables that subscription. Credit packs use temporary Checkout Session products.
export const anywayProducts = {
  basic_monthly: { productId: 'PRD26GCBT6PNZ7R3K', paymentLinkId: 'PL269TLI90RA0CGG', paymentLinkUrl: 'https://app.anyway.sh/pay/PL269TLI90RA0CGG' },
  basic_yearly: { productId: 'PRD26ZUWYQ4N2KPP0', paymentLinkId: 'PL26138JABFA9XB7', paymentLinkUrl: 'https://app.anyway.sh/pay/PL26138JABFA9XB7' },
  plus_monthly: { productId: 'PRD26GFDNHIW3AT36', paymentLinkId: 'PL26UTAW4SD0F2DA', paymentLinkUrl: 'https://app.anyway.sh/pay/PL26UTAW4SD0F2DA' },
  plus_yearly: { productId: 'PRD2692HTTT1J7ECT', paymentLinkId: 'PL26QFDN44PUNV3X', paymentLinkUrl: 'https://app.anyway.sh/pay/PL26QFDN44PUNV3X' },
  pro_monthly: { productId: 'PRD26PSVIVOETSRMT', paymentLinkId: 'PL26OI3KBVSVWH8S', paymentLinkUrl: 'https://app.anyway.sh/pay/PL26OI3KBVSVWH8S' },
  pro_yearly: { productId: 'PRD26GL9CRCKQ2VSN', paymentLinkId: 'PL26MZOTURG09I5Z', paymentLinkUrl: 'https://app.anyway.sh/pay/PL26MZOTURG09I5Z' },
  credit_pack_1100: { enabled: true },
  credit_pack_3500: { enabled: true },
  credit_pack_7200: { enabled: true },
  credit_pack_11500: { enabled: true },
  credit_pack_26000: { enabled: true },
  credit_pack_58000: { enabled: true },
};
